import { useState, useEffect } from 'react';
// The trigger will catch if all of the promiseActions are in fulfilled and immediately resets them and you may also pass one useCallback function to call when that reset happens
export const useMount = () => {
	const [hasMounted, setHasMounted] = useState(false);
	useEffect(() => {
		setHasMounted(true);
	}, [hasMounted]);
	return hasMounted;
};
